import ComplexidadeService from "@/views/RecursosPropriosQuestionarios/shared/services/ComplexidadeService";
import QuestionarioService from "../../services/QuestionarioService";

export default {
  mixins: [QuestionarioService, ComplexidadeService],
  data() {
    return {
      complexidades: [
        {
          idQuestionarioComplexidade: "",
          tipoComplexidade: {
            id: "",
            tipoComplexidade: ""
          }
        }
      ]
    };
  },
  computed: {
    // pega o tipo de questionario do vuex store
    tipoQuest() {
      return this.$store.getters.getTipoQuestionario.tipoQuestionario;
    },
    pullComplexidade() {
      return this.$store.getters.getPullComp;
    },
    listaComplexidades() {
      const payloadServidor = this.$store.getters.getPayloadComplexidades;
      const combo = this.$store.getters.getComboComplexidades;

      if (payloadServidor.length > 0)
        return this.verificaComplexidades(combo, payloadServidor);

      return combo;
    }
  },
  beforeMount() {
    if (this.tipoQuest) {
      this.inicializarComplexidades();
    }
  },
  methods: {
    async inicializarComplexidades() {
      if (this.pullComplexidade) return;

      this.$store.commit("setPullComplexidades", true);

      const complexidades = this.$store.getters.getPayloadServidor(
        "complexidades"
      );

      const payloadComplexidades = this.formataComplexidades(complexidades);
      this.$store.commit("setPayloadComplexidades", payloadComplexidades);

      const comboComplexidades = await this.getComplexidades(
        this.$store.getters.getTipoQuestionario.tipoQuestionario
      );

      this.$store.commit(
        "setComboComplexidades",
        this.formataComplexidades(comboComplexidades.data)
      );
    },
    formataComplexidades(array) {
      const objetoComplexidade = [];
      if (!array || array.length < 1) return objetoComplexidade;
      array.forEach(complexidade => {
        complexidade["selecionado"] = false;
        objetoComplexidade.push(complexidade);
      });
      return objetoComplexidade;
    },
    verificaComplexidades(combo, payloadServidor) {
      payloadServidor.forEach(questionarioComplexidade => {
        combo.forEach(complexidade => {
          if (questionarioComplexidade.tipoComplexidade.id == complexidade.id) {
            complexidade.selecionado = true;
          }
        });
      });
      return combo;
    },
    preparaDadosComplexidade() {
      const objetoQuestionarioComplexidade = [];
      const complexidadesSelecionadas = this.listaComplexidades.filter(
        complexidade => complexidade.selecionado
      );
      complexidadesSelecionadas.forEach(complexidade => {
        objetoQuestionarioComplexidade.push({
          idQuestionarioComplexidade: "",
          tipoComplexidade: complexidade
        });
      });
      return objetoQuestionarioComplexidade;
    }
  },
  watch: {
    // inicializa servicos quando servidor responde com o tipo de questionario
    tipoQuest(quest) {
      if (quest) {
        this.inicializarComplexidades();
      }
    }
  }
};
